import { render } from "./FormBuilderRenderer.vue?vue&type=template&id=2c4f0cfe&scoped=true&ts=true"
import script from "./FormBuilderRenderer.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormBuilderRenderer.vue?vue&type=script&setup=true&lang=ts"

import "./FormBuilderRenderer.vue?vue&type=style&index=0&id=2c4f0cfe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c4f0cfe"],['__file',"src/js/components/FormBuilderRenderer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2c4f0cfe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2c4f0cfe', __exports__)) {
    api.reload('2c4f0cfe', __exports__)
  }
  
  module.hot.accept("./FormBuilderRenderer.vue?vue&type=template&id=2c4f0cfe&scoped=true&ts=true", () => {
    api.rerender('2c4f0cfe', render)
  })

}


export default __exports__